import { useAct } from 'DashboardUser/store'

export default function BooleanFilter({filterKey, closeConfiguration}) {
    const act = useAct();

    const dashboardField = useSel(s => s.dashboard.dashboardFields.find(f => 'field_' + f.id === filterKey) ?? null);
    const questions = useSel(s => s.dashboard.survey.questions);
    const filter = useSel(s => s.local.filters ? s.local.filters[filterKey] : null);

    const [value, setValue] = useState(filter);

    const labels = () => {
        switch(dashboardField?.source) {
            case 'search': return ['Yes', 'No'];
            case 'goal': return ['Completed goal', 'Not completed goal'];
            case 'subscription': return ['Is subscribed', 'Not subscribed'];
            case 'resubscription': return ['Is subscribed', 'Not subscribed'];
            default: return ['Yes', 'No'];
        }
    }

    const setFilter = (val) => {
        act.local.setFilter(filterKey, val);
        setValue(val);
        closeConfiguration();
    }

    const clearFilter = () => {
        act.local.setFilter(filterKey, null);
        setValue(null);
        closeConfiguration();
    }

    return <div className="boolean-filter">
        <a href="#" className="filter-configuration-option" onClick={() => setFilter('[true]')}>{labels()[0]}</a>
        <a href="#" className="filter-configuration-option" onClick={() => setFilter('[false]')}>{labels()[1]}</a>
        {filter && <>
            <div className="filter-configuration-option-divider"></div>
            <a href="#" className="filter-configuration-option filter-configuration-clear" onClick={clearFilter}>Clear</a>
        </>}
    </div>

}